import { render } from "./Licenses.vue?vue&type=template&id=3cac3c52"
import script from "./Licenses.vue?vue&type=script&lang=ts"
export * from "./Licenses.vue?vue&type=script&lang=ts"
script.render = render

export default script